import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import UploadPage from './components/UploadPage';
import Results from './components/Results';
import Contact from './components/Contact';
import ContactUs from './components/ContactUs';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import ComplianceDashboard from './components/ComplianceDashboard';
import PlanComparison from './components/PlanComparison';
import AboutUs from './components/AboutUs';
import OurHardware from './components/OurHardware';
import NotFound from './components/NotFound';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import ComingSoon from './components/ComingSoon';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import EmailVerification from './components/EmailVerification';
import VerificationEmailSent from './components/VerificationEmailSent';
import { Toaster } from 'sonner';
import { AuthProvider } from './contexts/AuthContext';
import { isComingSoon, isLandingOnly } from './utils/buildMode';

function App() {
  if (isComingSoon) {
    return (
      <div className="min-h-screen">
        <ComingSoon />
        <Toaster 
          position="top-right"
          richColors
          duration={10000}
          visibleToasts={3}
          expand={true}
          closeButton={true}
          toastOptions={{
            duration: 10000,
          }}
        />
      </div>
    );
  }

  // Landing-only build: marketing pages only, no login/register or authenticated areas.
  const appRoutes = isLandingOnly ? (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/pricing" element={<PlanComparison />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/hardware" element={<OurHardware />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/results/:videoId" element={<Results />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  ) : (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/verify-email" element={<EmailVerification />} />
      <Route path="/verify-email/:token" element={<EmailVerification />} />
      <Route path="/verification-email-sent" element={<VerificationEmailSent />} />
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/pricing" element={<PlanComparison />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/hardware" element={<OurHardware />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/upload" element={
        <ProtectedRoute>
          <UploadPage />
        </ProtectedRoute>
      } />
      <Route path="/results/:videoId" element={<Results />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/compliance-dashboard" element={
        <ProtectedRoute>
          <ComplianceDashboard />
        </ProtectedRoute>
      } />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );

  return (
    <AuthProvider>
      <Router>
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow">
            {appRoutes}
          </main>
          <Footer />
          <Toaster 
            position="top-right"
            richColors
            duration={10000}
            visibleToasts={3}
            expand={true}
            closeButton={true}
            toastOptions={{
              duration: 10000,
            }}
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
